<template>
    <div>
        <!-- <section> -->
        <div style="margin: 5px 10px; display: flex; justify-content: space-between">
            <span style="color: #000; font-weight: bold">{{ $tx('hygl.components.meetingAgenda', '会议议题') }}:</span>
            <!-- <el-button v-if="vo.wfNodeNames==='拟稿'" style="float: right;" @click="innerVisible = true">选择议题</el-button> -->
            <div style="display: flex; justify-content: flex-end">
                <!-- <i class="el-icon-plus" style="line-height: 40px;color:#198618;font-weight: bold;"></i> -->
                <el-button v-model="vo" v-listpage-dialog :disabled="vo.wfNodeNames === '拟稿' ? false : true" style="float: right; line-height: 38px; padding-top: 0px !important; padding-bottom: 0px !important; border: 0px; padding-left: 6px !important" listviewurl="hygl.ytap.listCot" :dialog-title="$tx('hygl.components.selectMeeting')" exclude-fields="status" retain-btns="addObject" :multiple="true" name="selectTask">
                    <i class="el-icon-plus el-icon--left" style="line-height: 40px; color: #198618; font-weight: bold"></i>
                    {{ $tx('hygl.components.selectMeeting') }}
                </el-button>
            </div>
        </div>
        <!-- <p style="width: 96%; margin: 0 2%;"><span style="float: left;">会议议题</span><el-button v-if="vo.wfNodeNames==='拟稿'" style="float: right;" @click="innerVisible = true">选择议题</el-button></p> -->
        <div class="lyy-wrap el-table--border">
            <el-table border :data="tableData" class="lyy-table el-table--border" style="width: 100%; border-left: none">
                <!-- style="width: 96%;margin: 0 2%;margin-bottom:20px;margin-top:20px;" -->
                <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" width="45" />
                <el-table-column :label="$tx('hygl.components.meetingAgenda', '会议议题')" align="left" prop="flSubject" />
                <el-table-column :label="$tx('hygl.components.reporter', '汇报人')" align="center" prop="reportPersonName" width="80" />
                <el-table-column :label="$tx('hygl.components.reportTime', '汇报时长(分钟)')" align="center" prop="reportTime" width="110px" />
                <el-table-column :label="$tx('hygl.components.durationTime', '讨论时长(分钟)')" align="center" prop="talkTime" width="110px" />
                <el-table-column :label="$tx('hygl.components.attachNum', '附件数量')" align="center" width="80">
                    <template #default="scope">
                        <span style="cursor: pointer" @click="downloadFuc(scope.row.id, scope.row.passenger.ytNum)">{{ scope.row.passenger.ytNum }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$tx('hygl.components.order')" align="center" prop="status" width="80">
                    <template #default="scope">
                        <div style="color: #409efe; cursor: pointer">
                            <i v-if="(scope.$index < tableData.length && scope.$index !== tableData.length - 1) || scope.$index === 0" class="el-icon-bottom" style="font-weight: 700; font-size: 20px" @click="changeSort(scope.$index, 1)" />
                            <i v-if="scope.$index !== 0" class="el-icon-top" style="font-weight: 700; font-size: 20px" @click="changeSort(scope.$index, 0)" />
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :label="$tx('pageBtns.operate', '操作')" align="center" width="80">
                    <template #default="scope">
                        <el-button type="text" :style="{ color: vo.wfNodeNames !== '已结束' ? '#409EFE' : '#999', cursor: vo.wfNodeNames !== '已结束' ? 'pointer' : 'default' }" font-size="20px" @click="vo.wfNodeNames !== '已结束' ? delChecked(scope.$index, scope.row) : ''">{{ $tx('hygl.common.del') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- </section> -->
        <!-- <el-dialog
      width="1000px"
      title="选择议题"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div v-if="innerVisible" class="right-toolbar-container" style="margin-bottom:20px;">
        <el-input v-model="innerSearchText" placeholder="搜索..." clear="searchBar" :style="'width:960px'" @keyup.enter.native="doSearchTextInner">
          <el-button slot="append" icon="el-icon-search" style="width:30px;" @click.native="doSearchTextInner" />
        </el-input>
      </div>
      <data-table
        v-if="innerVisible"
        :on-list-data-before-load="onListDataBeforeLoad"
        :module-info="moduleInfo"
        :tb-columns="tbColumns1"
        :toolbar-btns="listpageBtns"
        :on-selected-rows-change="onSelectedRowsChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button :icon="'el-icon-close'" :disabled="doing" @click="close">关闭</el-button>
        <el-button type="primary" :disabled="doing" :icon="'el-icon-check'" @click="zpConfirm">提交</el-button>
      </span>
    </el-dialog> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            moduleInfo: {
                listpageViewUrl: 'hygl.ytap.listMyAll.vue',
                formTemplate: 'ytap',
                moduleCode: 'ytap',
                listDataUrl: '/hygl/ytap/listdataAndAttachNum?urlsearch=status:2;isChoice:0',
                listDefaultOrderBy: '',
                winWidth: 1000, // 查看、编辑窗口宽度
                winHeight: 600 // 查看、编辑窗口高度
            },
            tbColumns1: [
                {
                    field: 'state',
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    field: 'flSubject',
                    title: '会议议题',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true
                },
                {
                    field: 'reportPersonName',
                    title: '汇报人',
                    width: '80px',
                    align: 'center',
                    valign: 'middle',
                    sortable: true
                },
                {
                    field: 'reportTime',
                    title: '汇报时长(分钟)',
                    width: '130px',
                    align: 'center',
                    valign: 'middle',
                    sortable: true
                },
                {
                    field: 'talkTime',
                    title: '讨论时长(分钟)',
                    width: '130px',
                    align: 'center',
                    valign: 'middle',
                    sortable: true
                },
                {
                    field: 'status',
                    title: '状态',
                    width: '80px',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    elementFormatter: '0：草稿\r\n1：处理中\r\n2：结束\r\n8：已归档\r\n9：已注销\r\n'
                },
                {
                    field: 'column_operate',
                    title: '操作',
                    width: '80px',
                    align: 'center',
                    valign: 'middle'
                }
            ],
            // 列表页面操作按钮定义
            listpageBtns: [
                {
                    id: 'btn_deleteId',
                    btnName: '选择',
                    btnClick: this.chooseItem,
                    btnPermission: 'deleteIds',
                    btnType: 'column',
                    btnIcon: '',
                    color: '#409efe'
                }
            ],
            innerVisible: false,
            selectedRows: [],
            selectString: '',
            tableData: [],
            innerSearchText: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {
        if (this.vo.ytObject) {
            this.tableData = JSON.parse(this.vo.ytObject)
        }
        console.log(this.vo)
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad: function ($scope, qparams) {
            // qparams.creatorId = this.loginUser.personId
            console.log('ytap listdata before load..')
        },

        downloadFuc(id, num) {
            if (num > 0) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/ytap/downloadByBusiDataId?busiDataId=' + id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
            }
        },
        // 删除
        delChecked(index, row) {
            const _this = this
            this.tableData.forEach((item) => {
                if (item.id === row.id) {
                    _this.tableData.splice(index, 1)
                    _this.vo.ytObject = JSON.stringify(this.tableData)
                    _this.$message.success(_this.$tx('hygl.message.delSuccess'))
                    return false
                }
            })
        },
        // 通用列表选择对话框-选择数据后回调
        async onSelectListpageRowCompleted(selectedRows, attr) {
            // console.log(attr.listviewurl, 'onSelectListpageRowCompleted', attr, selectedRows)
            if (selectedRows.length > 0) {
                var newArr = []
                // const daat = this.tableData.filter((item, index) => {
                //     return this.tableData[index].id === selectedRows.id
                // })

                if (this.tableData.length > 0) {
                    var daraArrIds = []
                    this.tableData.forEach((item) => {
                        daraArrIds.push(item.id)
                    })
                    newArr = selectedRows.filter(function (item, index, array) {
                        return !daraArrIds.includes(item.id)
                    })
                    for (let i = 0; i < newArr.length; i++) {
                        this.tableData.push(newArr[i])
                    }
                } else {
                    newArr = selectedRows
                    for (let i = 0; i < newArr.length; i++) {
                        this.tableData.push(newArr[i])
                    }
                }
                this.innerVisible = false
                this.vo.ytObject = JSON.stringify(this.tableData)
                this.vo.ytId = []
                this.tableData.map((item, index) => {
                    this.vo.ytId.push(item.id)
                })
                this.vo.ytId = this.vo.ytId.toString()
                // this.$http({
                //     contentType: 'application/x-www-form-urlencoded',
                //     url: `/dbgl/task/batchUpdate`,
                //     method: 'PUT',
                //     data: newArr
                // }).then(res => {
                //     if (res.code === 'success') {
                //         // 成功
                //         this.getData()
                //     } else {
                //         // this.$message.error(res.message)
                //     }
                // })
            }
        },
        doSearchTextInner() {
            const searchMap = {}
            searchMap['flSubject'] = this.innerSearchText
            this.$bus.emit('refreshListData', searchMap, 'or')
        },
        chooseItem(row) {
            const daat = this.tableData.filter((item, index) => {
                return this.tableData[index].id === row.id
            })
            if (daat.length > 0) {
                this.$message.error(this.$tx('hygl.message.isSelectYt'))
                return false
            } else {
                this.tableData.push(row)
            }
            this.innerVisible = false
            this.vo.ytObject = JSON.stringify(this.tableData)
            this.vo.ytId = []
            this.tableData.map((item, index) => {
                this.vo.ytId.push(item.id)
            })
            this.vo.ytId = this.vo.ytId.toString()
            console.log(this.vo.ytObject, 245)
        },
        zpConfirm(row) {
            console.log('提交', row)
        },
        close() {
            this.innerVisible = false
        },
        // 上移下移
        moveFuc(a, type, index) {
            if (type === 'up') {
                this.tableData[index - 1] = this.tableData.splice(index, 1, this.tableData[index - 1])
            } else if (type === 'down') {
                this.swapArray(this.tableData, index, index + 1)
            }
        },
        changeSort(index, type) {
            this.tableData.splice(type ? index : index - 1, 1, ...this.tableData.splice(type ? index + 1 : index, 1, this.tableData[type ? index : index - 1]))
            this.vo.ytObject = JSON.stringify(this.tableData)
        },
        swapArray(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0]
            return arr
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table-toolbar {
    display: none;
}
/deep/ .el-dialog__body .el-table--fit {
    height: 496px;
    overflow: auto;
}
// /deep/.lyy-wrap .el-table--border{
//   // border-top: none !important;

// }
</style>
